import { useInAppState } from 'contexts/InAppProvider';
import { useMemo } from 'react';
import { parseUserAgent, UseClientType } from '@diritto/common/utils/userAgent';

export const useClient = () => {
  const { userAgent } = useInAppState();
  return useMemo(() => parseUserAgent(userAgent ?? ''), [userAgent]) as UseClientType;
};
